import styled, { css } from "styled-components";
// Utils
import { media } from "utils/media";

export const Footer = styled.div`
  padding: 20px 0 20px 0;
  margin-top: 43px;
  color: ${props => props.theme.colors.black.colorBlack20};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  ${props =>
    props.isFormActive
      ? css`
          ${media.PHONE`
            padding: 20px 0;
            margin-top: 6px;
          `};
        `
      : css`
          ${media.PHONE`
            padding: 0;
            margin-top: -29px;
        `};
        `}
`;

export const FooterLink = styled.a`
  color: ${props => props.theme.colors.black.colorBlack20};
  text-decoration: underline;
  font-family: Inter sans-serif;
`;
